// components/product/ProductFeatures.jsx
import React from 'react';
import { FiLock, FiTruck, FiCreditCard } from 'react-icons/fi';

const ProductFeatures = ({ isDarkMode }) => {
  const features = [
    { icon: FiLock, label: 'Secure', color: 'blue' },
    { icon: FiTruck, label: 'Free Pickup', color: 'green' },
    { icon: FiCreditCard, label: 'Instant Cash', color: 'purple' },
  ];

  const getColorClasses = (color) => {
    switch(color) {
      case 'blue':
        return isDarkMode 
          ? 'bg-blue-900/30 text-blue-400' 
          : 'bg-blue-100 text-blue-600';
      case 'green':
        return isDarkMode 
          ? 'bg-emerald-900/30 text-emerald-400' 
          : 'bg-emerald-100 text-emerald-600';
      case 'purple':
        return isDarkMode 
          ? 'bg-purple-900/30 text-purple-400' 
          : 'bg-purple-100 text-purple-600';
      default:
        return isDarkMode 
          ? 'bg-gray-700 text-gray-400' 
          : 'bg-gray-100 text-gray-600';
    }
  };

  return (
    <>
      <div>
        <div className="grid grid-cols-3 gap-3 mt-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`flex flex-col items-center p-2 text-center rounded-lg ${
                isDarkMode ? 'bg-gray-700' : 'bg-white border border-gray-100'
              }`}
            >
              <div className={`p-1.5 mb-1 rounded-full ${getColorClasses(feature.color)}`}>
                <feature.icon size={14} />
              </div>
              <p className={`text-[10px] font-medium ${
                isDarkMode ? 'text-gray-300' : 'text-gray-700'
              }`}>
                {feature.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ProductFeatures;